export default {
  site: {
    name: "白云视频",
    subtitle: "免费高清在线影视平台",
    description: "白云视频官网，提供西瓜视频免费和西瓜视频一样的在线看剧体验，免费看电影电视剧，高清不卡顿的视频平台。",
    keywords: "白云视频,西瓜视频免费,西瓜视频,糖豆视频,小蓝视频,免费看电影,免费看电视剧,高清视频在线,免费影视,不卡顿视频,在线看剧,免费视频",
  },
  nav: {
    home: "首页",
    movies: "电影",
    tvShows: "电视剧",
    variety: "综艺",
    anime: "动漫",
    articles: "影视资讯",
    about: "关于我们",
  },
  home: {
    heroTitle: "海量影视 免费观看",
    heroSubtitle: "高清不卡顿，随时随地享受精彩内容",
    heroCTA: "立即观看",
    hotToday: "今日热播",
    latestUpdate: "最新更新",
    recommendForYou: "为你推荐",
    viewAll: "查看全部",
  },
  video: {
    play: "播放",
    episode: "集",
    updateTo: "更新至",
    score: "评分",
    actors: "主演",
    director: "导演",
    genre: "类型",
    region: "地区",
    year: "年份",
    description: "简介",
  },
  article: {
    readMore: "阅读全文",
    publishedAt: "发布时间",
    source: "来源",
    relatedArticles: "相关文章",
  },
  about: {
    title: "关于白云视频",
    brandIntro: "品牌介绍",
    reputation: "口碑评价",
    contact: "联系我们",
    brandDesc: "白云视频是一个致力于为用户提供免费高清在线影视观看体验的平台。我们聚合了海量电影、电视剧、综艺、动漫等内容资源，以流畅的播放体验和简洁的界面设计，让每一位用户都能轻松享受观影乐趣。",
  },
  common: {
    home: "首页",
    back: "返回",
    loading: "加载中...",
    noData: "暂无数据",
    breadcrumbSeparator: ">",
  },
  footer: {
    copyright: "© 2026 白云视频 版权所有",
    privacy: "隐私政策",
    terms: "服务条款",
    disclaimer: "免责声明：本站内容来源于互联网，仅供学习和交流使用，请于下载后24小时内删除。",
  },
};